var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconViewoff({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eye",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.999,
    height: 13.277,
    viewBox: "0 0 19.999 13.277",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M11.372,14.74a3.37,3.37,0,1,1,3.372-3.37A3.381,3.381,0,0,1,11.372,14.74Zm0-5.055a1.685,1.685,0,1,0,1.686,1.685A1.691,1.691,0,0,0,11.372,9.685Z",
    transform: "translate(-1.373 -4.732)",
    fill: "#97a2b3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M9.949,17.277C3.726,17.277.24,11.3.074,11.053a.754.754,0,0,1,0-.83C.24,9.975,3.726,4,9.949,4s9.709,5.975,9.875,6.224a.754.754,0,0,1,0,.83C19.658,11.3,16.173,17.277,9.949,17.277ZM1.817,10.639c.83,1.245,3.734,4.979,8.132,4.979s7.3-3.734,8.132-4.979c-.83-1.245-3.734-4.979-8.132-4.979s-7.3,3.734-8.132,4.979Z",
    transform: "translate(0.05 -4)",
    fill: "#97a2b3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconViewoff);
export default __webpack_public_path__ + "static/media/icon_viewoff.3e0fcf5701bcdfe2670b1ba1a6817a92.svg";
export { ForwardRef as ReactComponent };